/**
 * @typedef {object} LeaderboardState
 * @property {LeaderboardNavState} nav
 * @property {any} data
 * @property {any} filter
 */

/**
 * @typedef {object} LeaderboardNavState
 * @property {number|null} round
 * @property {string} club
 */
